import auth from '../auth/duck';
import workspace from '../workspace/duck';
import invite from '../invite/duck';
import projects from '../projects/duck';
import projectDetails from '../projects/details/duck';
import projectMemos from '../memos/duck';
import userGoalsMemos from '../goals/memos/duck';
import user from '../user/duck';
import users from '../user/users/duck';
import events from '../events/duck';
import userEvents from '../updates/user-updates/duck';
import newsletters from '../newsletters/duck';
import invites from '../admin/invites/duck';

const reducers = {
  auth,
  workspace,
  invite,
  projects,
  user,
  users,
  events,
  userEvents,
  projectDetails,
  projectMemos,
  userGoalsMemos,
  newsletters,
  invites,
};

export default reducers;



// WEBPACK FOOTER //
// ./src/core/reducers.js